/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AttachPaperclipIcon20Light = forwardRef('AttachPaperclipIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M12.45 3.956a3.245 3.245 0 0 1 4.59 4.589l-7.128 7.128a4.618 4.618 0 0 1-6.53-6.53l4.96-4.962a.5.5 0 0 1 .708.707L4.089 9.85a3.618 3.618 0 1 0 5.116 5.117l7.128-7.128a2.245 2.245 0 1 0-3.175-3.175l-7.015 7.015a.872.872 0 1 0 1.234 1.234l4.848-4.849a.5.5 0 1 1 .707.707L8.084 13.62a1.873 1.873 0 1 1-2.648-2.648l7.014-7.015Z" })));
});
